export default "__VITE_ASSET__BlvVKfP9__"